import React from 'react';
import { useLoaderData } from 'react-router-dom';
import image from '../../assets/images/banner.png'
import Quize from '../Quize/Quize';
const Home = () => {
	const allData = useLoaderData();
	const quizes = allData.data;
	return (
		<div className='container'>
			<div className="row mb-5 justify-content-center align-items-center">
				<div className="col-sm-6">
					<h1 className='mt-5'>A Community of web based Quizzers.</h1>
					<p className='mt-3'>A quiz is a form of game or mind sport in which players attempt to answer questions correctly about a certain or variety of subjects. Quizzes can be used as a brief assessment in education and similar fields to measure growth in knowledge, abilities, or skills.</p>
				</div>
				<div className="col-sm-6 mt-3">
					<img src={image} alt="" className='w-100' />
				</div>
			</div>
			<h1 className='text-center mb-5'>The Part of Quizzes</h1>
			<div className="w-100 mx-auto row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
				{
					quizes.map(quize => <Quize
						key={quize.id}
						quize={quize}
					>
					</Quize>)
				}
			</div>
		</div>
	);
};

export default Home;